module.exports = __webpack_public_path__ + "static/media/icon-sm-circle.ba15a472.svg";